export default __webpack_public_path__ + "static/media/Analytics_icon.4ca316b4.svg";